import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../hooks/axios/useAxios";
import { documentRequestInfoUrl } from "../../constants/api/endpoints";


export const useDocumentRequests = () => {
  const axios = useAxios();
  
  return useQuery({
    queryKey: ["documentRequests"],
    queryFn: async () => {
      const response = await axios.get(
        documentRequestInfoUrl,
        {}
      );
      return response.data;
    },
  });
};